<template>
  <div>
    <BasicSingleVideo :title="title" :videosrc="videosrc" :videoposter="videoposter" :videopostermob="videopostermob" :videofullsrc="videofullsrc" :maidiansuffix="maidiansuffix"></BasicSingleVideo>
  </div>
</template>
<script>
import BasicSingleVideo from '@/components/basic-single-video.vue'
export default {
  components: {
    BasicSingleVideo
  },
  data() {
    return {
      title:'',
      videosrc: 'https://img.kia.cn/content/video/20240423/snkv.mp4',
      videofullsrc:'https://img.kia.cn/content/video/20240423/KIaSonet_USP.mp4',
      videoposter: 'https://img.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/video/mainpc.png',
      videopostermob: 'https://www.kia.cn/assets/~/media/images/vehicle/sonet/mainpage/video/spfmmob.png',
      maidiansuffix:'sonet视频'
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>

</style>
